import { nanoid } from "nanoid";

export const lessons = Array.from(Array(5)).map(() => lesson());

function lesson() {
  return {
    id: nanoid(),
    channelName: "Matemática Show com Prof. Abraão",
    channelUrl: "https://www.youtube.com/channel/UCpb_oCNCS8PbUX6zHJ_fAsA",
    duration: 645,
    humanizedDuration: "10:45",
    thumbnailUrl: null,
    title: "Definição da função do 2º grau",
    videoUrl: "https://www.youtube.com/watch?v=uWp9ZTvmBz0",
    watchedAt: null,
    topics: [
      {
        id: 5,
        name: "Matemática",
        slug: "matematica",
        group: { name: "Ciências Exatas", slug: "ciencias-exatas" },
        children: [
          {
            id: 16,
            slug: "equacao-do-segundo-grau",
            name: "Equação do segundo grau",
            children: []
          }
        ]
      }
    ]
  };
}
